/**
 * Proofing Service API Client Configuration
 *
 * This file provides the configuration function for the auto-generated API client.
 * It configures base URL and credentials.
 *
 * This file is outside the proofingService-client folder to prevent
 * it from being overwritten when regenerating the client.
 *
 * Note: Error interceptors are registered separately to avoid circular dependencies.
 */

import { config as appConfig } from "@/config";
import type { CreateClientConfig } from "./proofingService-client/client.gen";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: appConfig.proofingService.url,
  credentials: "include",
});
